import Country from "@bimproject/country";

import { useFinder } from "../../../../../../modules/finder";

export default function CountryFinderPlugin(props) {
    const { Component, onSelect, exclude = [] } = props;

    const { token } = useFinder();

    return Country
        .all()
        .filter((countryCode) => !exclude.includes(countryCode))
        .filter(
            (countryCode) => {
                if (!token) return true;
                if (countryCode.toLowerCase() === token.toLowerCase()) return true;
                if (token.length > 1) {
                    const country = Country.fromCode(countryCode);
                    if (country.name.toLowerCase().includes(token.toLowerCase())) return true;
                }
                return false;
            }
        )
        .map(
            (country) => (
                <Component
                    code={ country }
                    key={ country }
                    onClick={ () => onSelect(country) }
                />
            )
        );
}
